export { withPerfMarker } from './src/with-perf-marker';
